import localForage from "localforage";
import { PersistedBase64 } from "../models/notice";

export async function getFile(key: string): Promise<PersistedBase64 | undefined> {
  const item = await localForage.getItem<PersistedBase64>(key);
  return item === null ? undefined : item;
}

export async function setFile(file: PersistedBase64) {
  const persistedFile = await getFile(file.id);

  if (persistedFile) {
    return file;
  }

  return localForage.setItem(file.id, file);
}

export async function deleteFile(key: string) {
  return localForage.removeItem(key);
}
